module.exports = __webpack_public_path__ + "img/chadle_adv_21.8298f61a.png";